import axiosInstance from "./index.services";

export async function StudentImport(data: FormData){
  const response = await axiosInstance.post("/student/import-students/", data, {
    headers: { "Content-Type": "multipart/form-data"},
  });
  return response;
}